import { InjectionToken } from "@angular/core";
import { IGroupCreateUpdateModalService } from "./i-group-create-update-modal.service";

export const groupCreateUpdateModalServiceInjectionToken: InjectionToken<IGroupCreateUpdateModalService> = new InjectionToken<IGroupCreateUpdateModalService>("digital-signage.user-dashboard.dashboard-web.GroupCreateUpdateModalService");
